import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import jsPDF from 'jspdf';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Personal } from 'src/app/Models/personal/personal';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-print-ventas-diarias',
  templateUrl: './print-ventas-diarias.component.html',
  styleUrls: ['./print-ventas-diarias.component.css']
})
export class PrintVentasDiariasComponent implements OnInit {
  constructor(
    private reportViewer: ReportViewerService,
    private data: DataService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) { }
  mes: string = '1';
  idvende: string = '1';
  public detfactus: any[] = [];
  totalcantidad: number = 0;
  totalefectivo: number = 0;
  totalfise: number = 0;
  totalyape: number = 0;
  totaltarjetacredito: number = 0;
  totalcredito: number = 0;
  totalgeneral: number = 0;
  public personal: Personal = new Personal()
  public today = new Date();
  public fecinicio: any;
  public fecfin: any;
  public filtro: Filtro = new Filtro()
  public sucursal: number;
  @ViewChild('pagina', null) public pagina: ElementRef;

  ngOnInit() {
  }

  // GetData(filtro: Filtro) {
  //   this.data.Post('reporte_diario', filtro).subscribe({
  //     next: (r) => {
  //       console.log(r);
  //       if (r.message === "success") {
  //         this.detfactus = r.data;
  //         this.fecinicio = filtro.fecini;
  //         this.fecfin = filtro.fecfin;
  //         this.GetTotalVentas();
  //         this.cdr.detectChanges();
  //         setTimeout(() => {
  //           this.printerVentasDiarias();
  //         }, 0); // Espera a que el DOM se actualice
  //       } else {
  //         this.detfactus = [];
  //         console.warn("No se pudo obtener datos. Mensaje:", r.message);
  //         this.printerVentasDiarias();
  //       }
  //     },
  //     error: (err) => {
  //       console.error("Error al obtener datos del reporte diario:", err);
  //       this.detfactus = [];
  //       this.printerVentasDiarias();
  //     }
  //   });
  // }

  GetData(filtro: Filtro) {
    this.data.Post('reporte_diario', filtro).subscribe({
      next: (r: any) => {
        console.log('Respuesta reporte diario:', r);
        if (r.message === "success") {
          this.detfactus = r.data;
          this.fecinicio = filtro.fecini;
          this.fecfin = filtro.fecfin;
          this.GetTotalVentas();
          this.cdr.detectChanges();
          setTimeout(() => {
            // Generar el PDF
            const blob = this.printerVentasDiarias();
            // Mostrar en el modal reutilizable
            if (blob) {
              const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
              this.reportViewer.mostrarPDF(
                blob,
                'Reporte de Ventas Diarias',
                `reporte_ventas_diarias_${fecha}.pdf`
              );
            }
          }, 0);
        } else {
          this.detfactus = [];
          console.warn("No se pudo obtener datos. Mensaje:", r.message);
        }
      },
      error: (err: any) => {
        console.error("Error al obtener datos del reporte diario:", err);
        this.detfactus = [];
      }
    });
  }

  // GetTotalVentas() {
  //   this.totalcantidad = 0;
  //   this.totalefectivo = 0;
  //   this.totalfise = 0;
  //   this.totalyape = 0;
  //   this.totaltarjetacredito = 0;
  //   this.totalcredito = 0;
  //   this.totalgeneral = 0;

  //   for (const item of this.detfactus) {

  //     this.totalcantidad += item.total_cantidad || 0;
  //     this.totalefectivo += item.total_efectivo || 0;
  //     this.totalfise += item.total_fise || 0;
  //     this.totalyape += item.total_yape || 0;
  //     this.totaltarjetacredito += item.total_tarjeta_credito || 0;
  //     this.totalcredito += item.total_credito || 0;
  //     this.totalgeneral += item.total_general || 0;
  //   }

  // }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  // printerVentasDiarias() {
  //   const doc = new jsPDF();
  //   const titulo = { text: 'REPORTE DIARIO', x: 90, y: 20 };


  //   // Función para agregar encabezado en cada página
  //   const addHeader = () => {
  //     doc.setFontSize(14);
  //     doc.text(titulo.text, titulo.x, titulo.y);
  //     const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
  //     const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

  //     doc.setLineWidth(0.5);  // Establecer el grosor de la línea
  //     doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
  //     doc.setFontSize(11);
  //     // doc.text(`Vendedor:  ${this.personal.nombre}`, 10, 28);
  //     doc.text(`Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`, 10, 33);
  //     doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 33);
  //     //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
  //     doc.setFontSize(12);
  //   };

  //   // Columnas de la tabla

  //   const tableColumn = ['VENDEDOR', 'CANTIDAD', 'EFECTIVO', 'FISE', 'YAPE', 'TARJETA CRED.', 'A CREDITO', 'TOTAL'];

  //   const tableRows: any[] = [];

  //   // Obtener filas de una tabla HTML (ejemplo)
  //   const rows = document.querySelectorAll('#ventasdiarias tbody tr');
  //   rows.forEach(row => {
  //     const cols = row.querySelectorAll('td');
  //     const data: any[] = [];
  //     cols.forEach(col => data.push(col.innerText));
  //     tableRows.push(data);
  //   });

  //   // Usar autoTable para generar la tabla
  //   (doc as any).autoTable({
  //     head: [tableColumn],
  //     body: tableRows,
  //     startY: 35,
  //     margin: { horizontal: 10, vertical: 30 },
  //     theme: 'grid',
  //     headStyles: {
  //       halign: 'center', // Centra los textos de los encabezados
  //     },
  //     columnStyles: {
  //       1: { halign: 'center' },
  //       2: { halign: 'center' },
  //       3: { halign: 'center' },
  //       4: { halign: 'center' },
  //       5: { halign: 'center' },
  //       6: { halign: 'center' },
  //       7: { halign: 'center' },
  //       8: { halign: 'center' }
  //       // Alinear la columna "Cantidad" (índice 3) a la derecha
  //     },
  //     styles: {
  //       fontSize: 8,  // Controla el tamaño de fuente para todo el contenido de la tabla
  //       cellPadding: 1,  // Espaciado interno de las celdas
  //     },
  //     didDrawPage: (data: any) => {
  //       // Encabezado en cada página

  //       const pageNumber = data.pageNumber;  // Obtener el número de página
  //       //const pageCount = doc.getNumberOfPages();

  //       console.log(data.totalPages);

  //       addHeader();
  //       const pagetext = `Página ${pageNumber} `;
  //       doc.text(pagetext, 170, 15);  // Añade tu imagen
  //     },
  //     didDrawHeader: (data: any) => {
  //       doc.setFontSize(10);
  //       doc.text('VENDEDOR', data.settings.margin.left, data.cursor.y);
  //       doc.text('CANTIDAD', data.settings.margin.left + 30, data.cursor.y);
  //       doc.text('EFECTIVO', data.settings.margin.left + 60, data.cursor.y);
  //       doc.text('FISE', data.settings.margin.left + 90, data.cursor.y);
  //       doc.text('YAPE', data.settings.margin.left + 120, data.cursor.y);
  //       doc.text('TARJETA CRED.', data.settings.margin.left + 150, data.cursor.y);
  //       doc.text('A CREDITO', data.settings.margin.left + 180, data.cursor.y);
  //       doc.text('TOTAL', data.settings.margin.left + 210, data.cursor.y);

  //     }
  //   });

  //   // Guardar el archivo PDF
  //   doc.autoPrint({ variant: 'non-conform' });

  //   const blob = doc.output('blob');
  //   const url = URL.createObjectURL(blob);

  //   const iframe = document.createElement('iframe');
  //   iframe.style.display = 'none';
  //   iframe.src = url;
  //   document.body.appendChild(iframe);

  //   iframe.onload = () => {
  //     if (iframe.contentWindow) {
  //       iframe.contentWindow.print();
  //     }
  //   };
  //   //doc.save('informe.pdf');

  // }

  GetTotalVentas() {
    this.totalcantidad = 0;
    this.totalefectivo = 0;
    this.totalfise = 0;
    this.totalyape = 0;
    this.totaltarjetacredito = 0;
    this.totalcredito = 0;
    this.totalgeneral = 0;

    for (const item of this.detfactus) {
      this.totalcantidad += item.total_cantidad || 0;
      this.totalefectivo += item.total_efectivo || 0;
      this.totalfise += item.total_fise || 0;
      this.totalyape += item.total_yape || 0;
      this.totaltarjetacredito += item.total_tarjeta_credito || 0;
      this.totalcredito += item.total_credito || 0;
      this.totalgeneral += item.total_general || 0;
    }
  }

  // Método printerVentasDiarias adaptado para retornar Blob
  printerVentasDiarias(): Blob | null {
    const doc = new jsPDF();
    const titulo = { text: 'REPORTE DIARIO', x: 90, y: 20 };

    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);
      const lineY = titulo.y + 1;
      doc.setLineWidth(0.5);
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      doc.text(`Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`, 10, 33);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 33);
      doc.setFontSize(12);
    };

    // Columnas de la tabla (orden correcto según el HTML)
    const tableColumn = ['VENDEDOR', 'CANTIDAD', 'EFECTIVO', 'YAPE', 'FISE', 'TARJETA CRED.', 'A CREDITO', 'TOTAL'];
    const tableRows: any[] = [];

    // Construir filas desde detfactus con el orden correcto
    this.detfactus.forEach((item: any) => {
      const row: any[] = [];
      row.push(item.vendedor_nombre || '');  // vendedor_nombre según el HTML
      row.push(item.total_cantidad || 0);
      row.push(item.total_efectivo ? Number(item.total_efectivo).toFixed(1) : '0.0');
      row.push(item.total_yape ? Number(item.total_yape).toFixed(1) : '0.0');
      row.push(item.total_fise || 0);
      row.push(item.total_tarjeta_credito || 0);
      row.push(item.total_credito || 0);
      row.push(item.total_general ? Number(item.total_general).toFixed(1) : '0.0');
      tableRows.push(row);
    });

    // Agregar fila de totales (mismo orden)
    const rowTotal: any[] = [];
    rowTotal.push('TOTAL');
    rowTotal.push(this.totalcantidad);
    rowTotal.push(this.totalefectivo.toFixed(1));
    rowTotal.push(this.totalyape.toFixed(1));
    rowTotal.push(this.totalfise);
    rowTotal.push(this.totaltarjetacredito);
    rowTotal.push(this.totalcredito);
    rowTotal.push(this.totalgeneral.toFixed(1));
    tableRows.push(rowTotal);

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10 },
      theme: 'grid',
      headStyles: {
        halign: 'center',
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        fontStyle: 'bold'
      },
      columnStyles: {
        0: { halign: 'left' },     // Vendedor
        1: { halign: 'center' },   // Cantidad
        2: { halign: 'right' },    // Efectivo
        3: { halign: 'right' },    // Yape
        4: { halign: 'center' },   // Fise
        5: { halign: 'center' },   // Tarjeta
        6: { halign: 'center' },   // Crédito
        7: { halign: 'right' }     // Total
      },
      styles: {
        fontSize: 8,
        cellPadding: 1
      },
      didParseCell: (data: any) => {
        // Aplicar negrita a la última fila (totales)
        if (data.row.index === tableRows.length - 1 && data.section === 'body') {
          data.cell.styles.fontStyle = 'bold';
        }
      },
      didDrawPage: (data: any) => {
        addHeader();
        const pageNumber = data.pageNumber;
        doc.text(`Página ${pageNumber}`, 170, 15);
      }
    });

    // Retornar el blob en lugar de imprimir
    return doc.output('blob');
  }
}
